export default {
	styleOverrides: {
		root: {
			padding: '0px',
			overflow: 'unset',
		},
	},
};
